'use strict';

import SearchRoute from './SearchRoute';

export default function SearchRoutes({ 
    type, 
    routes = [], 
    onlyAirports,
    maxAirports,
    airports,
    requestMode = false,
    maxRoutes = 5,
    errors: userErrors, 
    containerClass: userContainerClass,
    dropDownParent,
    isOpenedInit = true,
    onFocus,
    onSearch, 
    onChangeRoutes,
}) {
    const [isOpened, setIsOpened] = React.useState(true);
    const [stateErrors, setStateErrors] = React.useState([]);
    const containerRef = React.useRef()
    
    React.useEffect(() => {
        if (routes.length > 1)
            setIsOpened(isOpenedInit);
    }, [ isOpenedInit ])
    
    const errors = [...(Array.isArray(userErrors) ? userErrors : []), ...(stateErrors || [])]
    
    const items = React.useMemo(() => {
        const items = [];
        routes.forEach((route, index) => {
            if (index === 0) {
                items.push({ ...route.from, joined: true })
                items.push({ ...route.to, joined: false })
                return
            }
            
            if (route.from.id === routes[index - 1].to.id) {
                items[items.length - 1].joined = true
                items.push({ ...route.to, joined: false })
            } else {
                items.push({ ...route.from, joined: true })
                items.push({ ...route.to, joined: false })
            }
        })
        
        return items;
    }, [ routes ]);

    const addRoute = (e, backRoute = null) => {
        e.preventDefault();

        let newRoutes = [...routes];
        if(newRoutes.length >= maxRoutes) return;

        let route = {from: {}, to: {}, date: '', time: '', seats: 0}
        if(backRoute !== null) {
            route = {
                ...newRoutes[backRoute],
                from: newRoutes[backRoute].to,
                to: newRoutes[backRoute].from,
                date: '',
                time: '',
                seats: 0,
            };
        }

        newRoutes.push(route);
        onChangeRoutes(newRoutes);
    }

    const removeRoute = (e, index) => {
        e.preventDefault();
        let newRoutes = [...routes];
        onChangeRoutes(routes.filter((r, i) => i !== index));
    }

    const handleChangeRoute = (index, route) => {
        let newRoutes = [...routes];
        newRoutes[index] = route;
        onChangeRoutes && onChangeRoutes(newRoutes);
    }

    const getRoutes = () => {
        return  ['planes', 'plane'].includes(type) ? routes : routes.slice(0, 1);
    }

    const validate = () => {
        let errors = [];
        let hasErrors = false
        routes.map((route, index) => {
            errors.push([]);
            if (!route.from.id) errors[index].push('from');
            if (!route.to.id) errors[index].push('to');
            if (!route.date) errors[index].push('date');
            if (type === 'planes') {
                if (!route.time) errors[index].push('time');
                if (!route.seats) errors[index].push('seats');
            }
            if (errors[index].length > 0) hasErrors = true;
        })
        
        setStateErrors(errors);
        return !hasErrors;
    }

    const handleSearch = () => {
        if (validate()) {
            if (routes.length > 1)
                setIsOpened(false)
            onSearch && onSearch()
        }
    }

    React.useEffect(() => {
        if (containerRef.current && !isOpened) {
            new Swiper(containerRef.current, {
                direction: "horizontal",
                freeMode: true,
                slidesPerView: "auto",
                scrollbar: false,
                mousewheel: true,
            });
            
        }
    }, [ routes, isOpened ])

    if (!requestMode && !isOpened && type === 'planes') {
        const itemsLength = items.length;
        if (!isOpened) {
            return <div className="sesrch-route">
                <div ref={containerRef} className="sesrch-route__row swiper">
                    <div className="swiper-wrapper">
                        {items.map((item, index) => (
                            <div className="swiper-slide" key={item.icao + index}>
                                <div className="route-item">
                                    {itemsLength <= 4 && <div className="route-item__text">{item.city}</div>}
                                    <span className={itemsLength <= 4 ? 'route-item__code' : ''}>{item.icao}</span>
                                    {item.joined && <i className="icon-plane2" />}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
                <div className="route-btn">
                    <a className="button button-base" onClick={() => setIsOpened(true)}>
                        <i className="icon-edit"></i> {tMsg('Изменить')}
                    </a>
                </div>
            </div>
        }
    }

    let containerClass = ['search', userContainerClass]
    if (type === 'sharing') containerClass.push('request-sharing')
    if (type === 'emptyleg') containerClass.push('request-el')

    return <div className={containerClass.join(' ')}>
        {getRoutes().map((route, index) => <SearchRoute
            key={index}
            type={type}
            dateRange={type === 'emptyleg'}
            index={index}
            route={route}
            errors={errors[index] || []}
            airports={airports}
            dropDownParent={dropDownParent}
            onlyAirports={onlyAirports}
            maxAirports={maxAirports}
            onChangeRoute={handleChangeRoute}
            onRemove={removeRoute}
            onSearch={handleSearch}
            onFocus={() => onFocus && onFocus()}
        />)}

        {type === 'planes' && <div className="search-btns">
            {routes.length < maxRoutes && routes[routes.length - 1].from.id && routes[routes.length - 1].to.id && <a href='#' className="search-button button-return" onClick={e => addRoute(e, routes.length - 1)}>
                <i className="icon-return"></i> {tMsg('Обратный перелёт')}
            </a>}
            {routes.length < maxRoutes && <a href='#' className="search-button button-add" onClick={addRoute}>
                <i className="icon-way"></i> {tMsg('Добавить маршрут')}
            </a>}
            <button className="search-button button-search" onClick={() => handleSearch()}>
                <i className="icon-search2"></i> {tMsg('Поиск')}
            </button>
        </div>}

        {type === 'plane' && routes.length < maxRoutes && <div className="search-btns__request">
            <a href='#' className="button-add" onClick={addRoute}>
                <span>+</span> {tMsg('Добавить маршрут')}
            </a>
            {routes.length === 1 && routes[0].from.id && routes[0].to.id && <a href='#' className="button-add" onClick={e => addRoute(e, 0)}>
                <i className="icon-arrow4"/> {tMsg('Обратный перелёт')}
            </a>}
        </div>}
    </div>
}